import { Skeleton } from '@components/Skeleton/Skeleton';

import styles from '../SideMenu.module.scss';

const menuItemLength = 6;

export const SideMenuSkeleton = () => {
  return (
    <div className={styles.skeletonWrapper} data-testid="skeleton-wrapper">
      {Array.from({ length: menuItemLength }).map((_, i) => (
        <div key={`sidemenu-skeleton-${i}`} className={styles.skeletonRow}>
          <div className={styles.skeletonGroupLeft} data-testid="skeleton-group-left">
            <Skeleton className={styles.skeleton} variant="text" width={24} height={28} />
            <Skeleton className={styles.skeleton} variant="text" width={169} height={28} />
          </div>
          <Skeleton className={styles.skeleton} variant="text" width={13} height={28} />
        </div>
      ))}
    </div>
  );
};
